import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

const STORAGE_KEY = "qi_cookie_consent";

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      const t = setTimeout(() => setVisible(true), 1400);
      return () => clearTimeout(t);
    }
  }, []);

  const choose = (choice) => {
    localStorage.setItem(STORAGE_KEY, choice);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-6 left-6 z-40 max-w-sm border border-white/10 bg-quantum-bg2/95 backdrop-blur-xl p-6 md:p-7 shadow-[0_20px_60px_rgba(0,0,0,0.6)]"
          data-testid="cookie-consent-banner"
          role="dialog"
          aria-label="Cookie consent"
        >
          <div className="h-px w-10 bg-quantum-gold mb-5" />
          <p className="text-sm text-quantum-muted leading-relaxed mb-2">
            We use a minimal set of cookies to keep this site secure and improve your experience.
          </p>
          <Link
            to="/cookies"
            data-testid="cookie-consent-learn-more"
            className="inline-block text-xs uppercase tracking-[0.2em] text-quantum-gold hover:text-quantum-text transition-colors mb-6"
          >
            Read our Cookie Policy
          </Link>
          <div className="flex gap-3">
            <button
              onClick={() => choose("accepted")}
              data-testid="cookie-accept-button"
              className="flex-1 text-xs uppercase tracking-[0.2em] px-5 py-3 bg-quantum-gold text-black hover:bg-white transition-colors duration-300 active:scale-95"
            >
              Accept
            </button>
            <button
              onClick={() => choose("declined")}
              data-testid="cookie-decline-button"
              className="flex-1 text-xs uppercase tracking-[0.2em] px-5 py-3 border border-white/15 text-quantum-muted hover:text-quantum-text hover:border-quantum-gold transition-colors duration-300 active:scale-95"
            >
              Decline
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
